import { prefersReducedMotion } from '@theme/utilities';

const SECTION_SELECTOR = '#MainContent .shopify-section:not(:first-child)';
const VISIBLE_CLASS = 'scroll-reveal--visible';

if (!prefersReducedMotion()) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(VISIBLE_CLASS);
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );

  const observeSections = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (!section.classList.contains(VISIBLE_CLASS)) observer.observe(section);
    });
  };

  observeSections();

  // Re-observe sections the theme editor or section-rendering API swaps in later.
  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    new MutationObserver(observeSections).observe(mainContent, { childList: true, subtree: true });
  }
}
